import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './_core/auth.guard';
import { RoleGuard } from './_core/role.guard';
import { RoleRedirectGuard } from './_core/role-redirect.guard';

const routes: Routes = [
  {
    path: 'app',
    loadChildren: () => import('./routes/app/app.module').then(module => module.DriverPortalModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./routes/login/login.module').then(module => module.LoginModule)
  },
  {
    path: 'resetar-senha',
    loadChildren: () => import('./routes/login/login.module').then(module => module.LoginModule),
    data: {
      state: 'resetar'
    }
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'notification',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN', 'GESTOR']},
        loadChildren: () => import('./routes/notification/notification.module').then(module => module.NotificationModule)
      },
      {
        path: '',
        loadChildren: () => import('./routes/home/home.module').then(module => module.HomeModule)
      },
      {
        path: 'travel-map',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN', 'CLIENTE', 'GESTOR']},
        loadChildren: () => import('./routes/travel-map/travel-map.module').then(module => module.TravelMapModule)
      },
      {
        path: 'travels',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN', 'CLIENTE', 'GESTOR']},
        loadChildren: () => import('./routes/travels/travels.module').then(module => module.TravelsModule)
      },
      {
        path: 'users',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN', 'CLIENTE']},
        loadChildren: () => import('./routes/users/users.module').then(module => module.UsersModule)
      },
      {
        path: 'tasks',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN','GESTOR']},
        loadChildren: () => import('./routes/tasks/tasks.module').then(module => module.TasksModule)
      },
      {
        path: 'checklist',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN', 'GESTOR']},
        loadChildren: () => import('./routes/checklist/checklist.module').then(module => module.ChecklistModule)
      },
      // {
      //   path: 'lacre',
      //   canActivate: [RoleGuard],
      //   data: {roles: ['ADMIN']},
      //   loadChildren: () => import('./routes/lacre/lacre.module').then(module => module.LacreModule)
      // },
      {
        path: 'drivers',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN', 'SUPORTE'], permissions: ['addDriver']},
        loadChildren: () => import('./routes/drivers/drivers.module').then(module => module.DriversModule)
      },
      {
        path: 'shared',
        canActivate: [RoleGuard],
        data: {roles: ['CLIENTE', 'ADMIN']},
        loadChildren: () => import('./routes/travel-shared-admin/travel-shared-admin.module').then(module => module.TravelSharedAdminModule)
      },
      {
        path: 'kmm',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN']},
        loadChildren: () => import('./routes/kmm/kmm.module').then(module => module.KmmModule)
      },
      {
        path: 'terms',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN', 'GESTOR', 'CLIENTE']},
        loadChildren: () => import('./routes/terms/terms.module').then(module => module.TermsModule)
      },
      {
        path: 'messages',
        canActivate: [RoleGuard],
        data: {roles: ['ADMIN']},
        loadChildren: () => import('./routes/modal-notification/modal-notification.module').then(module => module.ModalNotificationModule)
      },
      {
        path: 'treinamento',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN', 'GESTOR'] },
        loadChildren: () =>
          import('./routes/treinamento/treinamento.module').then(
            (module) => module.TreinamentoModule
          ),
      },
      {
        path: 'logs',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN'] },
        loadChildren: () => import('./routes/logs/logs.module').then(module => module.LogsModule)
      },
      {
        path: 'feedback',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN'] },
        loadChildren: () =>
          import('./routes/feedback/feedback.module').then(
            (module) => module.FeedbackModule
          ),
      },
      {
        path: 'support',
        canActivate: [RoleGuard],
        data: { roles: ['ADMIN', 'SUPORTE'] },
        loadChildren: () =>
          import('./routes/support/support.module').then(
            (module) => module.SupportModule
          ),
      },


      // {
      //   path: 'notify',
      //   canActivate: [RoleGuard],
      //   data: {roles: ['ADMIN', 'GESTOR']},
      //   loadChildren: () => import('./routes/whatsapp-sender/whatsapp-sender.module').then(module => module.WhatsappSenderModule)
      // },
      // {
      //   path: 'add-notify',
      //   loadChildren: () => import ('./routes/tstnotification/tstnotification.module').then(module => module.TstnotificationModule)
      // },
      // {
      //   path: 'route',
      //   canActivate: [RoleGuard],
      //   data: {roles: ['ADMIN']},
      //   loadChildren: () => import ('./routes/route/route.module').then(module => module.RouteModule)
      // },
      // {
      //   path: 'rescue',
      //   canActivate: [RoleGuard],
      //   data: {roles: ['ADMIN']},
      //   loadChildren: () => import ('./routes/rescue/rescue.module').then(module => module.RescueModule)
      // },
      // {
      //   path: 'freight',
      //   canActivate: [RoleGuard],
      //   data: {roles: ['ADMIN','GESTOR']},
      //   loadChildren: () => import('./routes/freight/freight.module').then(module => module.FreightModule)
      // },
      
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
